import { axiosInstance } from "./";

const clientReportsPath = (eventId) => `/events/${eventId}/client_reports`;

/**
 * GET /admin_portal/v2/events/:eventId/client_reports — read-only list (PROLINE-3640).
 * Pagination metadata comes back in the `Current-Page` / `Total-Count` / `Total-Pages`
 * headers. `page: -1` returns every report unpaginated. `403` when the admin lacks
 * `Manage Reports` `can_view`.
 */
const getAdminClientReports = (eventId, params = {}) =>
  axiosInstance.get(clientReportsPath(eventId), { params });

/**
 * GET /admin_portal/v2/events/:eventId/client_reports/:id — returns a fresh `upload_url`.
 * Silent: the download flow shows its own error message, not the global loader.
 */
const getAdminClientReport = (eventId, id) =>
  axiosInstance.get(`${clientReportsPath(eventId)}/${id}`, {
    handlerEnabled: false,
  });

export { getAdminClientReports, getAdminClientReport };
